import { RootState } from '@/redux/store';

export const selectPizzaData = (state: RootState) => state.pizza;
